







































































































import CreditCardForm from '@/components/payments/CreditCardForm.vue';
import GetSonyPaymentToken from '@/components/payments/GetSonyPaymentToken.vue';
import SavedCardForm from '@/components/payments/SavedCardForm.vue';
import { Component, Vue } from 'vue-property-decorator';
import { SubscriptionRepository } from '@/repositories/SubscriptionRepository';
import { SubscriptionInfo } from '@/models/Subscription';
import { InputCard } from '@/models/InputCard';
import { SUBSCRIPTION_TENANT_ID } from '@/common/constants';
import {
  threeDSecureAuth,
  getThreeDSecureAuthResult
} from '@/common/threeDSecureUtils';
import { ErrorWithCode } from '@/common/customErrors';
@Component({
  components: {
    CreditCardForm,
    SavedCardForm,
    GetSonyPaymentToken
  }
})
export default class P0227 extends Vue {
  // クレジットカード情報（表示用）
  subscriptionInfo = {} as SubscriptionInfo;
  // 入力されたクレジットカード情報
  inputCard: InputCard = {
    number: '',
    expYear: '',
    expMonth: '',
    securityCode: '',
    holderName: ''
  };
  // カードトークン
  token = '';
  buttonLoading = false;
  // クレジットカード更新失敗時エラーメッセージ
  updateErrorMsg = '';
  // クレジットカード更新処理以外でのエラーメッセージ
  errorMsg = '';
  // 3Dセキュア認証結果
  threeDSecureAuthResult = '';
  $refs!: {
    CreditCardForm: CreditCardForm;
    GetSonyPaymentToken: GetSonyPaymentToken;
  };
  // カード更新時にcreated()の処理を待たずに画面描画されてしまう挙動に対する制御フラグ
  isInitialized = false;
  // カード登録時にセットする0円の支払い金額
  readonly PAY_AMOUNT_FOR_REGISTRATION = 0;

  get subscriptionRepo() {
    return new SubscriptionRepository();
  }

  async created() {
    await this.initialize();
    // 処理を待ってから画面描画する
    this.isInitialized = true;
  }

  async initialize() {
    // encryptValueを取得する
    this.threeDSecureAuthResult = getThreeDSecureAuthResult(this.$route.query);
    if (this.threeDSecureAuthResult) {
      // サブスク登録情報が成功している、かつencryptValue付きの場合は3Dセキュア認証後のリダイレクトと判断し、クレジットカード情報変更処理を実施する
      await this.changeCardInfo();
      return;
    }
    // サブスク登録情報を取得する
    await this.getRegisterInfo();
  }

  // サブスク登録情報を取得する
  async getRegisterInfo() {
    try {
      const res = await this.subscriptionRepo.getSubscriptionInfo();
      this.subscriptionInfo = res;
    } catch (errCode) {
      this.handleGetRegisterInfoErr(errCode);
    }
  }

  handleGetRegisterInfoErr(errCode: any) {
    switch (errCode) {
      case 42200:
        this.errorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 42206:
        this.$router.push({ name: 'manage-subscription' });
        break;
      case 50000:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      case 50001:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      default:
        this.errorMsg = this.$msg.get('2000078');
        break;
    }
  }

  getPaymentToken() {
    this.buttonLoading = true;
    this.$refs.CreditCardForm.$validator.validateAll().then(valid => {
      if (valid) {
        this.$refs.GetSonyPaymentToken.getPaymentToken(
          this.inputCard.number,
          this.inputCard.expYear,
          this.inputCard.expMonth,
          this.inputCard.securityCode
        );
      } else {
        this.buttonLoading = false;
      }
    });
  }

  async handleToken(token: string, err: any) {
    if (err) {
      this.errorMsg = this.$msg.get('2000075');
      this.buttonLoading = false;
    } else {
      this.token = token;
      await this.threeDSecureAuthCaller();
    }
  }

  async changeCardInfo() {
    try {
      await this.$router.push({ query: undefined });
      // eslint-disable-next-line no-empty
    } catch {}
    // 現在と同じページにvue-routerで移動しようとしたときにNavigationDuplicatedエラーが発生するが、クエリパラメータを変更するためには仕方ないのでエラーを許容する
    // created()の中の処理の場合エラーが発生しないが念の為try/catchしておく。

    try {
      await this.subscriptionRepo.updateSubscriptionCard(
        this.threeDSecureAuthResult
      );
      // 変更完了画面に遷移
      await this.$router.push({
        name: 'change-subscription-creditcard-complete'
      });
    } catch (errCode) {
      this.handleUpdateErr(errCode);
      // 「お支払いいただいているカード情報」表示のためサブスク登録情報を取得する
      await this.getRegisterInfo();
    }
  }

  // eslint-disable-next-line complexity
  handleUpdateErr(errCode: any) {
    switch (errCode) {
      case 40018:
      case 40019:
      case 42200:
        this.updateErrorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 42201:
        this.updateErrorMsg = this.$msg.get('2000070', {
          errorCode: errCode
        });
        break;
      case 42203:
        this.updateErrorMsg = this.$msg.get('2000070', {
          errorCode: errCode
        });
        break;
      case 42204:
        this.updateErrorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      case 42206:
        this.updateErrorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 42213:
        this.updateErrorMsg = this.$msg.get('2000120');
        break;
      case 50000:
      case 50001:
      case 50011:
      case 50012:
        this.updateErrorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      default:
        this.updateErrorMsg = this.$msg.get('2000075');
        break;
    }
  }

  /**
   * 3Dセキュア認証の共通関数呼び出し
   */
  async threeDSecureAuthCaller() {
    const redirectUrl = `${process.env.VUE_APP_SERVICE_URL}/account-info/paid-services/change-creditcard`;
    try {
      await threeDSecureAuth(
        redirectUrl,
        SUBSCRIPTION_TENANT_ID,
        this.PAY_AMOUNT_FOR_REGISTRATION,
        this.inputCard.holderName,
        this.token
      );
    } catch (e) {
      this.buttonLoading = false;
      if (e instanceof ErrorWithCode) {
        switch (e.code) {
          case 40017:
          case 40004:
            this.errorMsg = this.$msg.get('2000074', {
              errorCode: e.code
            });
            break;
          case 50000:
            this.errorMsg = this.$msg.get('2000071', {
              errorCode: e.code
            });
            break;
          default:
            this.errorMsg = this.$msg.get('2000075');
        }
        return;
      }
      this.errorMsg = this.$msg.get('2000075');
    }
  }
}
